import React from 'react'
import Link from 'next/link'
import { Article } from './index'

export type ArticleCardMiniProps = Omit<
  Article,
  'categoryName' | 'summary' | 'youTubeId' | 'postDateText' | 'tags' | 'categoryName'
>

export const ArticleCardMini = ({ title, url, mainImage, onCardClick }: ArticleCardMiniProps) => {
  return (
    <article>
      <Link
        onClick={() => url && onCardClick && onCardClick(url)}
        prefetch={false}
        href={url}
        className="c-article-card-mini">
        {mainImage?.url ? (
          <div
            className="c-article-card-mini__image"
            style={{
              backgroundImage: `url(${mainImage?.url})`,
            }}></div>
        ) : null}
        <h5 className="c-article-card-mini__title h5">{title}</h5>
      </Link>
    </article>
  )
}
